export default {
    'remaining-samples': 'العينات المتبقية'
}